import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Auth } from 'aws-amplify';
import { AuthService } from './../../auth/auth.service';
import { CommonUtil } from '../../util/common-util';
import { ToastUtil } from '../../util/toast-util';
import { Constant } from './../../constant';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GeneralYesNoDialogComponent } from '../general-yes-no-dialog/general-yes-no-dialog.component';
import { DragDropModule, CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-tag-setting-dialog',
    templateUrl: './tag-setting-dialog.component.html',
    styleUrl: './tag-setting-dialog.component.css',
    standalone: false,
})
export class TagSettingDialogComponent {
  public form: FormGroup;
  public showSpinner = true;
  public isSaving = false;
  public btnEnable = false;
  public tags;
  public orderNum = Array(20);  // 表示順選択リスト用
  public titleMaxLen = 20;

  constructor(
    private dialogRef: MatDialogRef<TagSettingDialogComponent>,
    private auth: AuthService,
    private commonUtil: CommonUtil,
    private formBuilder: FormBuilder,
    private toastUtil: ToastUtil,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.getMaster();
    this.initForm();
  }

  drop(event: CdkDragDrop<any>) {

    const control = this.lists.at(event.previousIndex);

    this.lists.removeAt(event.previousIndex);
    this.lists.insert(event.currentIndex, control);

    this.lists.updateValueAndValidity();

    // 並び順を保存
    this.lists.controls.forEach((g, i) => {
      g.get('order_no')?.setValue(i + 1, {
        emitEvent: false
      });
    });

  }

  // 保存
  onSave() {
    if (!this.commonUtil.isOnline()) {
      this.toastUtil.clearAllShowingToast();
      this.toastUtil.showErrorToast('', Constant.msgNetworkError, Constant.toastShowMiliSec);
      return;
    }

    let delDialog = false;

    const sendData = [];

    this.lists.controls.forEach((control, index) => {

      const raw = control.getRawValue(); // disableされているtitleも取得できる

      if (raw.del_flg === 1) {
        delDialog = true;

        if (!raw.id) {
          return;
        }
      }

      sendData.push({
        id: raw.id,
        title: raw.title,
        order_no: index + 1,
        del_flg: raw.del_flg
      });

    });

    if (delDialog) {
       //削除確認ダイアログ表示
      const dialogRef = this.dialog.open(GeneralYesNoDialogComponent, {
        width: Constant.dialogWidth,
        autoFocus: false,
        data: { msg: Constant.msgConfirmDelTalenttag }
      });
      dialogRef.afterClosed().subscribe(isOK => {
        if (isOK) {
          // 登録実行
          this.postTagMaster(sendData);
        }
      });
    } else {
      this.postTagMaster(sendData);
    }
  }

  trackByForm(index: number, control: any) {
    return control.get('id')?.value ?? control;
  }

  // 追加
  onAdd() {
    const item = this.formBuilder.group({
      title: ['', [Validators.required, Validators.maxLength(this.titleMaxLen)]],
      order_no: [0],
      id: [''],
      del_flg: [0],
      cnt: ['0人']
    });

    // フォーム（中身）をフォーム（枠）に追加します
    this.lists.insert(0, item);
  }

  // 削除
  onDel(index: number) {

    this.lists.at(index).get('title')?.disable();
    this.lists.at(index).get('order_no')?.disable();

    this.lists.at(index).get('del_flg')?.setValue(1);

  }

  // 削除の取消
  onDelCancel(index: number) {

    this.lists.at(index).get('title')?.enable();
    this.lists.at(index).get('order_no')?.enable();

    this.lists.at(index).get('del_flg')?.setValue(0);

  }

  private initForm() {
    this.form = this.formBuilder.group({
      lists: this.formBuilder.array([]),
    });
  }


  // マスタ取得
  private getMaster() {
    Auth.currentSession().then(session => {
      const apiPath = '/tag/master';
      const options = this.auth.createApiHeader(session);

      this.commonUtil.apiGet(apiPath, options).then(res => {
        this.tags = res.data;
        this.createFormData();
        this.showSpinner = false;
        this.btnEnable = true;
        if (this.tags.length === 0) {
          // 追加
          this.onAdd();
        }
      })
      .catch(err => {
        console.log(err)
        this.showSpinner = false;
        this.toastUtil.clearAllShowingToast();
        this.toastUtil.showErrorToast('', Constant.msgNetworkError, Constant.toastShowMiliSec);
      });
    });
  }

  // 登録
  private postTagMaster(sendData) {
    this.isSaving = true;
    Auth.currentSession().then(session => {
      const apiPath = '/tag/master';
      const options = this.auth.createApiHeader(session);
      options['body'] = {tags: sendData};

      this.commonUtil.apiPost(apiPath, options).then(res => {
        this.toastUtil.showInformationToast('', Constant.msgResultSaveSuccess, Constant.toastShowMiliSec);
        // ダイアログ閉じる
        this.dialogRef.close(true);
      })
      .catch(err => {
        this.toastUtil.clearAllShowingToast();
        // 保存失敗エラー
        if (err.message === Constant.msgResultSaveFailed) {
          this.toastUtil.showErrorToast('', Constant.msgResultSaveFailed, Constant.toastShowMiliSec);
          this.dialogRef.close(true);
        } else {
          this.isSaving = false;
          this.toastUtil.showErrorToast('', Constant.msgSaveFailedRetry, Constant.toastShowMiliSec);
        }
      });
    });
  }

  private createFormData() {
    this.tags.forEach((obj) => {
      const item = {
        title: ['', Validators.required],
        order_no: [obj.order_no],
        id: [obj.id],
        del_flg: 0,
        cnt: [(obj.cnt ?? 0) + '人'],
      }
      const formItem = this.formBuilder.group(item);
      setTimeout(() => {
        formItem.patchValue({
          title: obj.title
        })
      });
      this.lists.push(formItem);
    });
  }

  get lists(): FormArray {
    return this.form.get('lists') as FormArray;
  }
}
